import { UseFormReturn } from "react-hook-form";
import { MiDetailFields } from "@miplatform/components";
import { INPUT_TYPES } from "@miplatform/constants";
import { IDepartmentResponse } from "@miplatform/types";
import { ConfigAccordionHeader } from "../../../components/ConfigAccordionHeader/ConfigAccordionHeader";
import { IRoleFormData } from "../../ConfigRoles.types";

export const RoleDepartmentTabView = ({
  form,
  extraTabProps,
}: {
  form: UseFormReturn<IRoleFormData>;
  extraTabProps?: {
    departmentsList?: IDepartmentResponse[];
    isReadOnly?: boolean;
  };
}) => {
  const { isReadOnly } = extraTabProps || {};
  const { watch, control } = form;
  const { departmentId } = watch();

  const departmentFields = [
    {
      label: "Department",
      value: departmentId || "Not assigned",
      fieldType: INPUT_TYPES.SELECT,
      name: "departmentId",
      options:
        extraTabProps?.departmentsList?.map((department) => ({
          label: department.name,
          value: department.id,
        })) || [],
      required: true,
      disabled: isReadOnly || extraTabProps?.isReadOnly,
    },
  ];

  return (
    <ConfigAccordionHeader title="Department">
      <MiDetailFields detailFields={departmentFields} control={control} />
    </ConfigAccordionHeader>
  );
};
